import request from "../../../../core/data/network/client/request";
import Api from "../../../../core/data/network/constants/api_routes";

export default {
  getHabeasData: async () => {
    return request.get(Api.getHabeasData());
  },
  getHabeasDataBySearch: async (term) => {
    return request.get(Api.getHabeasDataBySearching(term));
  },
  getHabeasDataBySearching: async (term) => {
    return request.get(Api.getHabeasDataBySearching(term));
  }   
};